import React from "react";

function SVGIconViewer({ value }) {
  const safeColor = "#3633fcff"; 
  const size = 35; 
  if (!value || typeof value !== "string") {
    return (
      <span
        dangerouslySetInnerHTML={{ __html: "" }}
        style={{ width: size, height: size }}
      />
    );
  }

  let finalSvg = value.replace(/{{COLOR}}/g, safeColor);

  const isValid = finalSvg.includes("<svg") && finalSvg.includes("</svg>");
  if (!isValid) {
    return (
      <span
        dangerouslySetInnerHTML={{ __html: "" }}
        style={{ width: size, height: size }}
      />
    );
  }

  finalSvg = finalSvg
    .replace(/width="[^"]*"/, `width="${size}"`)
    .replace(/height="[^"]*"/, `height="${size}"`);

  return (
    <span
      className="icon-viewer"
      style={{ width: size, height: size, display: "inline-block" }}
      dangerouslySetInnerHTML={{ __html: finalSvg }}
    />
  );
}

export default SVGIconViewer;
